import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "Important Notice",
    blocks: [
      { type: "p", text: "This platform contains confidential business systems, trade intelligence frameworks, proprietary software methodologies, strategic operating systems, investor materials, confidential commercial models, artificial intelligence workflows, platform architecture, and trade-secret methodologies owned exclusively by Delta GreenX." },
      { type: "p", text: "By accessing, browsing, testing, observing, evaluating, registering for, screen-sharing, participating in demonstrations, attending investor presentations, reviewing dashboards, or otherwise interacting with any portion of the platform, you expressly acknowledge and agree to be legally bound by this Agreement." },
      { type: "p", text: "If you do not agree to these terms, you must immediately terminate access." },
    ],
  },
  {
    heading: "Ownership of Platform Assets",
    blocks: [
      { type: "p", text: "The entire Delta GreenX ecosystem is the sole and exclusive property of Delta GreenX, including:" },
      { type: "ul", items: [
        "Software interfaces and dashboard arrangements",
        "Commercial methodologies and workflow structures",
        "Supply chain systems and corridor intelligence systems",
        "Market intelligence frameworks",
        "User journeys and onboarding frameworks",
        "Platform architecture and investor presentation logic",
        "Product terminology and interface designs",
        "Visual systems and trade scoring methodologies",
        "All associated derivatives",
      ]},
      { type: "p", text: "Access to this platform does not grant any ownership rights, replication rights, licensing rights, derivative rights, commercialization rights, sublicensing rights, benchmarking rights, consulting rights, advisory rights, or any other proprietary interest." },
      { type: "p", text: "Any attempt to imitate, reconstruct, redesign, commercialize, benchmark, document, diagram, summarize for competitive use, or otherwise exploit any component of the platform without written authorization shall constitute unauthorized intellectual property misuse and trade secret misappropriation." },
    ],
  },
  {
    heading: "Confidential Platform Access",
    blocks: [
      { type: "p", text: "Any content observed through this platform shall be treated as confidential information, including:" },
      { type: "ul", items: [
        "Visual workflows and product demonstrations",
        "Investor simulations and user journeys",
        "Onboarding logic",
        "Strategic operating models",
      ]},
      { type: "p", text: "Users may not disclose, circulate, transmit, discuss, summarize, publish, or otherwise communicate such information to any third party without prior written authorization." },
      { type: "note", text: "These confidentiality obligations survive indefinitely beyond account termination." },
    ],
  },
  {
    heading: "Platform Monitoring Consent",
    blocks: [
      { type: "p", text: "By entering the platform, users expressly consent to platform monitoring, including:" },
      { type: "ul", items: [
        "Session logging and access logging",
        "Identity verification",
        "Browser analysis and device fingerprinting",
        "IP intelligence and geographic verification",
        "Fraud detection systems and anomaly detection",
        "Access event logging",
        "Forensic audit trails for security and legal protection purposes",
      ]},
      { type: "p", text: "Delta GreenX reserves the right to investigate suspicious activity at its sole discretion." },
    ],
  },
  {
    heading: "Acceptance",
    blocks: [
      { type: "p", text: 'By clicking "ENTER PLATFORM," accessing any portion of Delta GreenX, participating in any demonstration, or otherwise interacting with platform assets, you expressly acknowledge electronic acceptance of these terms.' },
      { type: "p", text: "Such acceptance shall constitute a legally binding electronic signature enforceable under all applicable electronic commerce, digital transaction, arbitration, confidentiality, intellectual property, trade secret, and commercial enforcement laws." },
    ],
  },
];

export default function TermsOfUse() {
  return (
    <LegalLayout
      title="Master Platform Access Agreement"
      eyebrow="Legal · Master Agreement"
      effective="May 1, 2026"
      lastUpdated="May 1, 2026"
      intro={[
        "This Master Platform Access Agreement governs all access to and use of the Delta GreenX platform.",
        "By accessing the platform in any form, you agree to be legally bound by the terms set forth below.",
      ]}
      sections={sections}
      contact="legal@deltagreenx.com"
    />
  );
}
